// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__aQtQs","selected_tab":"styles_selected_tab__G59Ne","not_selected_tab":"styles_not_selected_tab__vMsbo"};